export default __webpack_public_path__ + "static/media/glass.cda64728.svg";